// Deal-alerts signup opens via the theme modal (see sections/deals-modal.liquid).
// This styles the inline Shopify Forms embed (rendered inside its shadow DOM) and reorders
// the checkbox-description fieldsets.
//
// RESILIENCE (2026-07-14): Shopify Forms uses CSS-module class names of the form
// `_<name>_<buildhash>_<n>` (e.g. `_formHeader_cit2d_24`). The <name> part is stable across
// builds; only <buildhash> regenerates. So we target the stable prefix via [class*="_name_"]
// (and semantic selectors like `button[type="submit"]` / `input#email` where possible) rather
// than the full hashed class — a Forms rebuild no longer silently drops the styling.
// The old permanent MutationObserver on document.body was replaced with a self-terminating
// interval (stops once the form is styled + fieldsets fixed, or after a max window).
(function () {
  var MAX_ATTEMPTS = 40; // ~12s at 300ms, then give up

  var CSS = `
/* checkbox rows */
[class*="_checkboxField_"] {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;
}
form[class*="_formFieldset_"] { gap: 4px !important; }
[class*="_formFieldContainer_"] { margin-top: 16px !important; }
[class*="_checkboxInput_"], input[type="checkbox"] { width: 16px; height: 16px; }

/* body copy */
span[class*="_textBody_"] {
  font-size: 14px !important;
  color: #252525 !important;
  font-family: 'Proxima_Nova_Bold' !important;
}
[class*="_textBody_"] p { font-size: 14px !important; color: #4D4D4D !important; }

/* headings */
h1[class*="_textHeading_"], h2[class*="_textHeading_"], h1, h2 {
  font-size: 32px !important;
  font-family: 'Proxima_Nova_Bold' !important;
  line-height: 40px !important;
}

/* header block */
section[class*="_formHeader_"] {
  margin: 5px auto 4px !important;
  text-align: center !important;
  margin-bottom: 10px !important;
}

/* email + text fields */
[class*="_formInputField_"], input[type="email"], input[type="text"] {
  border: 1px solid #ccc !important;
  border-radius: 0 !important;
  padding: 12px !important;
}
input[class*="_formInputField_"], input#email { box-shadow: unset !important; }
input#email {
  border: 1px solid #D1D1D1 !important;
  color: #000 !important;
}
[class*="_formFieldContainer_"] [class*="_inputFilled_"] { display: none; }

/* custom checkbox fieldsets + legend */
fieldset[name^="custom#"] { display: flex; flex-direction: column-reverse; }
legend {
  color: #4D4D4D !important;
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
  padding-left: 20px !important;
}

/* close button (popup layout residue) */
[class*="_formContainerCloseButtonPosition_"] {
  background: #F7F7F7 !important;
  padding: 7px !important;
}

/* submit button */
[class*="_formSubmitButton_"], button[type="submit"] {
  background: #007AA3 !important;
  color: #fff !important;
  border-radius: 0 !important;
  padding: 10px 16px !important;
  width: 100% !important;
  max-width: none !important;
  font-family: 'Proxima_Nova_Bold' !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  line-height: normal !important;
  padding-top: 11px !important;
  margin-top: 14px !important;
}

/* layout wrappers */
[class*="_gridItemContent_"] { max-width: 500px !important; position: relative !important; }
[class*="_noImage_"] { max-width: 500px !important; border-radius: 0 !important; }
[class*="_formDisclaimer_"] {
  position: static !important;
  text-align: center !important;
  margin: 10px 0 0 !important;
}
[class*="_verticalLayout_"] { gap: 0 !important; }

@media screen and (max-width: 768px) {
  [class*="_formContainerCloseButtonPosition_"] { top: 8px !important; right: 10px !important; }
  h1[class*="_textHeading_"], h2[class*="_textHeading_"], h1, h2 { font-size: 20px !important; line-height: normal !important; }
  [class*="_gridItem_"][class*="_gridItemContent_"] { padding: 16px !important; }
  section[class*="_formHeader_"] {
    margin-bottom: 10px !important;
    max-width: 300px;
    margin-left: auto !important;
    margin-right: auto !important;
  }
  [class*="_inline_"] [class*="_formContainer_"] { min-width: 350px !important; }
}
`;

  function styleForm(shadow) {
    if (shadow.querySelector('#custom-form-style')) return;
    var style = document.createElement('style');
    style.id = 'custom-form-style';
    style.textContent = CSS;
    shadow.appendChild(style);
  }

  // Move each custom fieldset's <legend> (description) under the checkbox layout.
  // Returns true when there is no more pending work.
  function reorderFieldsets(shadow) {
    var pending = false;
    shadow.querySelectorAll('fieldset[name^="custom#"]').forEach(function (fs) {
      if (fs.classList.contains('fixed-layout')) return;
      var legend = fs.querySelector('legend');
      var layout = fs.querySelector('[class*="_verticalLayout_"]');
      if (legend && layout) {
        layout.appendChild(legend);
        fs.classList.add('fixed-layout');
      } else {
        pending = true; // form not fully rendered yet
      }
    });
    return !pending;
  }

  var attempts = 0;
  var iv = setInterval(function () {
    attempts++;
    var embed = document.querySelector('shopify-forms-embed');
    var shadow = embed && embed.shadowRoot;
    if (shadow) {
      styleForm(shadow);
      reorderFieldsets(shadow);
    }
    if (attempts >= MAX_ATTEMPTS) clearInterval(iv);
  }, 300);
})();
